import InfoButton from './InfoButton';
import '../css/Pdp.css';
import ValidateValue from '../function/ValidateValue';

export function getSvlLockedPdpId(machineType) {
  if (machineType === 'SV-L-400-1300') {
    return 2322;
  }

  if (machineType === 'SV-L-300-900') {
    return 2321;
  }

  return null;
}

function PdpComponent({ inputs, setInputs, options, result }) {
  const numberPdp = inputs.pdp.length;
  const lockedSvlPdpId = getSvlLockedPdpId(inputs.machine_type);
  const isSvlPdpLocked =
    inputs.sv_family === 'SV-L' && lockedSvlPdpId !== null;

  const handlePdpChange = (index, checked) =>
    setInputs((prevInputs) => {
      const updatedPdp = prevInputs.pdp.map((item, i) =>
        i === index ? { ...item, selected: checked } : item
      );

      const updatedProductTbh = checked
        ? prevInputs.product_tbh
        : prevInputs.product_tbh.map((item) =>
            item.pdp === prevInputs.pdp[index].id
              ? { ...item, pdp: null }
              : item
          );

      return {
        ...prevInputs,
        pdp: updatedPdp,
        product_tbh: updatedProductTbh,
      };
    });

  const option = options.find((option) => option.field === 'number_pdp');
  const { validateValue, warning } = ValidateValue(
    option,
    inputs.number_pdp,
    inputs,
    result
  );

  return (
    <div className="pdp-container">
      {numberPdp > 0 && !validateValue && (
        <div className="tooltip-warning">
          <div className="tooltip warning bottom">{warning}</div>
        </div>
      )}
      {numberPdp > 0 && (
        <div className="glass pdp-table">
          <table>
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th>Name</th>
                <th>Max slope angle</th>
                <th>Product Stability angle</th>
                <th>Selected</th>
              </tr>
            </thead>
            <tbody>
              {inputs.pdp.map((pdp, index) => {
                const isPdpUsed = inputs.product_tbh.some(
                  (product) => product.pdp === pdp.id
                );
                return (
                  <tr key={pdp.id}>
                    <td>
                      <InfoButton
                        infoText={pdp.description}
                        align="height-text"
                      />
                    </td>
                    <td>
                      <img
                        src={`${process.env.PUBLIC_URL}/pics/pdp/${pdp.id}_icon_FC.png`}
                        alt={`PDP ${pdp.id}`}
                        className="pdp-image"
                      />
                    </td>
                    <td>{pdp.type}</td>
                    <td>{pdp.max_incline} °</td>
                    <td>
                      {result.slope_angle_center
                        ? `${Math.round(pdp.isa * result.slope_angle_center)} °`
                        : ''}
                    </td>
                    <td>
                      <div className="checkbox-container">
                        <input
                          className={`checkbox-input`}
                          type="checkbox"
                          name="pdp"
                          checked={pdp.selected}
                          disabled={isPdpUsed || isSvlPdpLocked}
                          id={`checkbox-${pdp.id}`}
                          onChange={(e) =>
                            handlePdpChange(index, e.target.checked)
                          }
                        />
                        <label
                          htmlFor={`checkbox-${pdp.id}`}
                          className="checkbox-label"
                        ></label>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default PdpComponent;
